import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {
  getregistrationValue: any = '';
  gridToPrint = '';
  isDigitalAsset: boolean = false;
  constructor() { }
  getTriggerMsg = new BehaviorSubject(false);
  getTriggerMsg$ = this.getTriggerMsg.asObservable();
  getFeaturesData = new BehaviorSubject<any>([]);
  getFeaturesData$ = this.getFeaturesData.asObservable();
  getAppRoleData = new BehaviorSubject<any>([]);
  getAppRoleData$ = this.getAppRoleData.asObservable();
  getAppPatchData = new BehaviorSubject<any>([]);
  getAppPatchData$ = this.getAppPatchData.asObservable();
  getAppFeaturesEmitData = new BehaviorSubject<any>([]);
  getAppFeaturesEmitData$ = this.getAppFeaturesEmitData.asObservable();
  private defaultSubscriptionObj = new BehaviorSubject({} as any);
  currentSubscriptionObj = this.defaultSubscriptionObj.asObservable();
  private defaultUserData = new BehaviorSubject({});
  currentUserData = this.defaultUserData.asObservable();

  changeSubscriptionObj(userData) {
    this.defaultSubscriptionObj.next(userData);
  }
  changeUserData(userData) {
    this.defaultUserData.next(userData);
  }
  private defaultFacilityBlockData = new BehaviorSubject({});
  currentFacilityBlockData = this.defaultFacilityBlockData.asObservable();
  changeFacilityData(FacilityBlockData) {
    this.defaultFacilityBlockData.next(FacilityBlockData);
  }
  dateChange(newdate):any {
    const _ = moment();
    const date = moment(newdate).add({hours: _.hour(), minutes:_.minute() , seconds:_.second()})   
    return date.toDate();
  }
  facilityMode = new BehaviorSubject({});
  facilityMode$ = this.facilityMode.asObservable();
  private defaultFacilityLayoutMasterData = new BehaviorSubject({});
  getFacilityLayoutMasterData = this.defaultFacilityLayoutMasterData.asObservable();
  setFacilityLayoutMasterData(layoutData) {
    this.defaultFacilityLayoutMasterData.next(layoutData);
  }
  setFacilityLayoutDetailsData(layoutData) {
    this.defaultFacilityLayoutDetailsData.next(layoutData);
  }
  private defaultFacilityLayoutDetailsData = new BehaviorSubject({});
  getFacilityLayoutDetailsData = this.defaultFacilityLayoutDetailsData.asObservable();
  changeProductBlockData(sectionData) {
    this.defaultProductBlockData.next(sectionData);
  }
  private defaultProductBlockData = new BehaviorSubject({});
  currentProductBlockData = this.defaultProductBlockData.asObservable();
  changeNewTimeBlock(timeBlock) {
    this.defaulTimeBlock.next(timeBlock);
  }
  private defaulTimeBlock = new BehaviorSubject({});
  currentTimeBlock = this.defaulTimeBlock.asObservable();
  changeTimeBlockData(timeBlockData) {
    this.defaultTimeBlockData.next(timeBlockData);
  }
  private defaultTimeBlockData = new BehaviorSubject({});
  currentTimeBlockData = this.defaultTimeBlockData.asObservable();
  private TimeBlockEdit = new BehaviorSubject<boolean>(false);
  isTimeBlockEdit = this.TimeBlockEdit.asObservable();
  changeTimeBlockEditMode(flag: boolean) {
    this.TimeBlockEdit.next(flag);
  }
  public newTimeBlock = new BehaviorSubject({})
  newTimeBlock$ = this.newTimeBlock.asObservable();
  private TimeBlockData = new BehaviorSubject({});
  editedTimeBlockData = this.TimeBlockData.asObservable();
  editTimeBlockData(eBlockData) {
    this.TimeBlockData.next(eBlockData);
  }

  setCareTrackDetailsData(layoutData) {
    this.defaultCareTrackDetailsData.next(layoutData);
  }
  private defaultCareTrackDetailsData = new BehaviorSubject({});
  getCareTrackDetailsData = this.defaultCareTrackDetailsData.asObservable();

  private initialAppData = new BehaviorSubject({});
  currentAppBlockData = this.initialAppData.asObservable();
  changeAppData(appBlockData) {
    this.initialAppData.next(appBlockData);
  }
  addCommunication = new BehaviorSubject({});
  addCommunication$ = this.addCommunication.asObservable();
  private defaultCommDetails = new BehaviorSubject(false);
  currentCommDetails = this.defaultCommDetails.asObservable();
  changeCommDetails(commDetails) {
    this.defaultCommDetails.next(commDetails);
  }

  addDigtialAsset = new BehaviorSubject({});
  addDigtialAsset$ = this.addDigtialAsset.asObservable();

  private defaultDigitalAsset = new BehaviorSubject(false);
  currentDigitalAsset = this.defaultDigitalAsset.asObservable();
  changeDigitalAsset(commDetails) {
    this.defaultDigitalAsset.next(commDetails);
  }
  private digitalFileUpload = new BehaviorSubject<boolean>(false);
  isDigitalFileUpload = this.digitalFileUpload.asObservable();

  changeDigitalFileUpload(flag: boolean) {
    this.digitalFileUpload.next(flag);
  }
  private defaultCommFilterData = new BehaviorSubject([]);
  currentCommFilterData = this.defaultCommFilterData.asObservable();

  changeCommHistoryData(commFilterData) {
    this.defaultCommFilterData.next(commFilterData);
  }
  private defaultCommFilterReset = new BehaviorSubject(false);
  currentCommFilterReset = this.defaultCommFilterReset.asObservable();

  changeCommFilterReset(resetValue) {
    this.defaultCommFilterReset.next(resetValue);
  }
  private completeUserData = new BehaviorSubject({});
  completeUserData$ = this.completeUserData.asObservable();
  changeCompleteUserData(userData) {
    this.completeUserData.next(userData);
  }
  //for asset
  private defaultAssetData = new Subject<any>()
  currentAssetData = this.defaultAssetData.asObservable();

  changeAssetData(assetData) {
    this.defaultAssetData.next(assetData);
  }
  
}
